module.exports = __webpack_public_path__ + "img/yl.26baa569.png";